import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import { Link } from "react-router-dom";
import { AddPageHeader } from "../Common/Utils";
import NewsTable from "../Common/NewsTable";

const Passports = () => {
  const [passports, setPassports] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getPassports().then((data) => setPassports(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("Passports, visas, and migration fraud")}
      <Divider align="center">
        <h1>Passports, visas, and migration fraud</h1>
      </Divider>
      <div className="privacy-terms">
        This page gathers the latest major news on passports, visas, and
        migration fraud. Information is also accessible via a dedicated{" "}
        <Link
          to="https://www.linkedin.com/showcase/passports-visas-and-migration-fraud/"
          target="_blank"
          rel="noreferrer"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          LinkedIn page
        </Link>{" "}
        and{" "}
        <Link
          to="/the-consular-newsletter"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          The Consular Newsletter
        </Link>
        . Are you a recognized press body? Interested in highlighting specific
        news? Please feel free to{" "}
        <Link
          to="/contact"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          contact
        </Link>{" "}
        the Center.
      </div>
      <br />
      <NewsTable data={passports} searchEnabled longDescription />
    </div>
  );
};

export default Passports;
